import { useEffect, useState } from 'react'
import { get } from 'helpers/api_helper'

// A null url reads nothing and drops what was read (a closed section); the private rows of a url are never returned for another one.
export default function useAudit(url) {
  const [retry, setRetry] = useState(0)
  const [state, setState] = useState({ url: null, loading: true, data: null, error: false })
  useEffect(() => {
    if (!url) { setState(current => current.url ? { url: null, loading: true, data: null, error: false } : current); return undefined }
    let current = true
    setState({ url, loading: true, data: null, error: false })
    get(url).then(response => {
      if (current) setState({ url, loading: false, data: response.data || null, error: !response.data })
    }).catch(() => { if (current) setState({ url, loading: false, data: null, error: true }) })
    return () => { current = false }
  }, [url, retry])
  const idle = { loading: Boolean(url), data: null, error: false }
  return { ...(url && state.url === url ? state : idle), retry: () => setRetry(value => value + 1) }
}
